import styled from 'styled-components';

export const DownloadNow = styled.a`
  display: block;
  margin: 0 auto;
  width: 200px;
  text-align: center;
  padding: 0 40px 20px;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: var(--color-accent);
`;
